
import Cookie from 'js-cookie'
import Checkout from '../components/stripe/Checkout.vue'
import TermsConditions from '../components/stripe/TermsConditions.vue'
import PoweredBy from '../components/stripe/PoweredBy.vue'
import { getTrialEndDate, formatPrice } from '../utils/utils'

const axios = require('axios')

export default {
  layout: 'server-render',
  components: {
    Checkout,
    TermsConditions,
    PoweredBy
  },
  transition(to, from) {
    if (!from) return 'fade'
    return +to.query.page > +from.query.page ? 'slide-right' : 'slide-left'
  },
  data() {
    return {
      checkoutIsCompleted: false,
      accessCode: null,
      isLoading: false,
      createCustomer: false,
      createSubscription: false,
      step: 1,
      codeWord: null,
      email: '',
      phone: '',
      password: '',
      passwordConfirm: '',
      validated: true,
      firstname: '',
      lastname: '',
      stripeCustomer: null,
      freeTrialDays: null,
      termsAccepted: false
    }
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price)
    },
    getChargeDate() {
      return getTrialEndDate(this.freeTrialDays)
    },
    isCheckoutLoading(isLoad) {
      this.isLoading = isLoad
    },
    processPayment() {
      if (!this.termsAccepted) {
        this.$snotify.error('You must agree to the terms and conditions to continue.')
        return
      }
      this.isLoading = true
      this.createCustomer = true
    },
    register(eventData, paymentMethod, invoice, custId) {
      this.isLoading = true
      this.$fireAuth.createUserWithEmailAndPassword(this.email, this.password).then(
        async (user) => {
          try {
            const token = await this.$fireAuth.currentUser.getIdToken()
            // Set JWT to the cookie
            Cookie.set('access_token', token, { expires: 7, sameSite: 'Strict' })

            const stripeSubscriptionId = eventData ? eventData.data.id : null
            const stripeCustomerId = eventData ? eventData.data.customer : custId
            const stripePaymentInfo = paymentMethod || null
            const purchasedProgramId = this.cartProd.price.metadata.programId

            await this.$fireStore
              .collection('clients-information')
              .doc(user.user.uid)
              .set({
                email: user.user.email,
                first_name: this.firstname,
                last_name: this.lastname,
                phone: this.phone,
                termsConditions: true,
                purchasedProducts: this.cartProd,

                // Payment details from stripe
                stripeSubscriptionId,
                stripeCustomerId,
                stripePaymentInfo,
                invoice: invoice || null
              })

            await this.$fireStore
              .collection('orders')
              .doc(user.user.uid)
              .collection('transactions')
              .add({
                purchasedProducts: this.cartProd,
                created: this.$fireStoreObj.FieldValue.serverTimestamp(),
                // Payment details from stripe
                stripeSubscriptionId,
                stripeCustomerId,
                stripePaymentInfo,
                invoice: invoice || null
              })

            await this.$fireStore
              .collection('clients')
              .doc(user.user.uid)
              .set({
                email: user.user.email,
                name: `${this.firstname} ${this.lastname}`
              })

            if (purchasedProgramId) {
              const purchasedOn = this.$fireStoreObj.FieldValue.serverTimestamp()
              await this.$fireStore
                .collection('clients-purchased-programs')
                .doc(user.user.uid)
                .collection('programs')
                .doc(purchasedProgramId)
                .set({
                  programId: purchasedProgramId,
                  purchasedOn
                })
              const globalProg = await this.$fireStore
                .collection('global-fitness-programs')
                .doc(purchasedProgramId)
                .get()
              const globalProgData = globalProg.data()
              if (globalProgData && globalProgData.programNutritions) {
                await this.$fireStore.collection('clients-nutritions').doc(user.user.uid).set({
                  nutritions: globalProgData.programNutritions
                })
              }

              if (globalProgData && globalProgData.programGroceries) {
                await this.$fireStore.collection('clients-groceries').doc(user.user.uid).set({
                  groceries: globalProgData.programGroceries
                })
              }

              if (globalProgData && globalProgData.programRecipes) {
                await this.$fireStore.collection('clients-recipes').doc(user.user.uid).set({
                  recipes: globalProgData.programRecipes
                })
              }
            } else {
              axios.post(`${process.env.API_URL}/updateNewProfile`, { userId: user.user.uid })
            }

            if (user.user) {
              // Analytics custom events
              this.$fireAnalytics.logEvent('account_creation')
              this.$fireAnalytics.setUserId(user.user.uid)

              this.isLoading = false
              this.checkoutIsCompleted = true
              this.handleAbandonedCart()
              localStorage.setItem('clientId', user.user.uid)
              this.$router.push({ name: 'dashboard', params: { id: user.user.uid } })
              this.$snotify.success(
                'Your profile has been created successfully.',
                `Welcome ${this.firstname}`
              )
            }
            this.isLoading = false
          } catch (error) {
            console.error(error)
          }
        },
        (err) => {
          this.isLoading = false
          this.$snotify.error(err.message)
        }
      )
    },
    prev() {
      if (this.step >= 2) {
        this.step -= 1
        this.scrollToTop()
      }
    },
    async next() {
      if (this.step >= 2) {
        this.scrollToTop()
        return
      }
      // eslint-disable-next-line
      const emailVal = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)

      if (!this.firstname.length) {
        this.validated = false

        this.$snotify.error('All fields must be filled in to continue')

        setTimeout(() => {
          this.validated = true
        }, 6000)

        return
      }

      if (!emailVal) {
        this.$snotify.error('Please enter a valid email.')
        return
      }

      if (this.password.length < 6 || this.password !== this.passwordConfirm) {
        this.$snotify.error('Your password must be at least 6 characters and match in both fields.')
        return
      }

      this.$fireAuth.fetchSignInMethodsForEmail(this.email).then((result) => {
        if (!result.length) {
          this.step += 1
          this.scrollToTop()
          this.handleAbandonedCart()
        } else {
          this.$snotify.error(
            'Account with this email already exist. Please login to continue your purchase.'
          )
        }
      })
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    async handleAbandonedCart() {
      const ifEmailExists = await this.$fireStore
        .collection('abandoned-cart')
        .where('email', '==', this.email)
        .get()

      if (!this.checkoutIsCompleted && ifEmailExists.size === 0 && this.cartProd) {
        await this.$fireStore.collection('abandoned-cart').doc().set({
          email: this.email,
          first_name: this.firstname,
          last_name: this.lastname,
          phone: this.phone,
          purchasedProducts: this.cartProd,
          timestamp: this.$fireStoreObj.FieldValue.serverTimestamp()
        })
      }

      if (this.checkoutIsCompleted && ifEmailExists.size === 1) {
        const documentRef = ifEmailExists.docs[0].ref
        await documentRef.delete()
      }
    }
  },
  mounted() {
    const legacyTrial = this.$route.query['free-trial']
    if (legacyTrial) {
      this.freeTrialDays = legacyTrial
    }
  },
  async created() {
    const { program } = this.$route.query
    if (this.stripePrograms[program]) {
      if (
        !this.cartProd
        || (this.cartProd && this.cartProd.product.id !== this.stripePrograms[program])
      ) {
        await this.$store.dispatch('getSingleProductStripe', this.stripePrograms[program])
      }
    }
    if (!this.cartProd) {
      this.$router.push('/programs')
    }
  },
  computed: {
    cartProd() {
      return this.$store.state.cart[0]
    },
    checkCodeWord() {
      return this.codeWord === this.accessCode
    },
    user() {
      return this.$store.state.user
    },
    stripePrograms() {
      return this.$store.state.stripePrograms
    }
  }
}
